<template>
  <div class="container assigned-partners">
    <div class="mt-2 col-md-12 col-sm-12">
      <div class="row">
        <h2>Assigned Partners</h2>
      </div>
    </div>
    <div class="mt-3 col-md-12 col-sm-12">
      <div class="row">
        <div class="col-md-4 col-sm-4">
          <div class="row">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <router-link
                  to="/trip-request/assigned-partners"
                  class="nav-link"
                  >Assigned Partners
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/trip-request/service-partners"
                  class="nav-link"
                  @click="changeComponent"
                  >In-Service Partners
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-8 col-sm-8">
          <form @submit.prevent="searchData">
            <div class="row">
              <div
                class="col"
                v-show="
                  this.permission.includes('assign-partner-search-name') ===
                  true
                "
              >
                <div class="input-group-sm">
                  <input
                    class="form-control"
                    type="search"
                    v-model="user_service.name"
                    placeholder="Search name"
                    aria-label="Search"
                  />
                </div>
              </div>
              <div
                class="col"
                v-show="
                  this.permission.includes('assign-partner-search-mobile') ===
                  true
                "
              >
                <div class="input-group-sm">
                  <input
                    class="form-control"
                    type="search"
                    v-model="user_service.mobile"
                    placeholder="Search mobile"
                    aria-label="Search"
                  />
                </div>
              </div>
              <div
                class="col"
                v-show="
                  this.permission.includes('assign-partner-search-list') ===
                  true
                "
              >
                <div class="input-group-sm">
                  <input
                    type="text"
                    class="form-control assignment-search"
                    v-model="searchFilter.globalSearch"
                    placeholder="Search Assign List"
                  />
                </div>
              </div>
              <div
                class="col"
                v-show="
                  this.permission.includes('assign-partner-status-filter') ===
                  true
                "
              >
                <div class="input-group-sm">
                  <select
                    class="form-select form-select-sm"
                    v-model="searchByStatus"
                  >
                    <option selected value="">Status</option>
                    <!--                    <option value='Interested'>Interested</option>-->
                    <!--                    <option value='Assigned'>Assigned</option>-->
                    <!--                    <option value='Confirmed'>Confirmed</option>-->
                  </select>
                </div>
              </div>
              <div
                class="col"
                v-show="
                  this.permission.includes('assign-partner-search-name') ===
                    true ||
                  this.permission.includes('assign-partner-search-mobile') ===
                    true ||
                  this.permission.includes('assign-partner-search-list') ===
                    true
                "
              >
                <button
                  type="submit"
                  id="assign-partner-search"
                  class="btn btn-primary btn-sm"
                >
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <br />
    <div class="mt-3 card text-center" style="margin-bottom: 50px">
      <div class="card-body">
        <div class="mt-3">
          <div v-if="isLoading" class="container">
            <div class="d-flex justify-content-center mt-5">
              <loader></loader>
            </div>
          </div>
          <div v-else>
            <div v-if="this.assignedLists.length > 0">
              <div class="table-responsive table-responsive-sm">
                <table class="table table-hover table-bordered" id="datatable">
                  <thead class="table-light">
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Total Trip</th>
                      <th>Total Payable</th>
                      <th>Payment/Trip</th>
                      <th>Bonus/Trip</th>
                      <th>Trip Earning (weekly)</th>
                      <th>Bonus (weekly)</th>
                      <th>Disbursed</th>
                      <th>Requested by</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-for="assignedLists in assignedLists"
                      :key="assignedLists.id"
                    >
                      <tr
                        @click="checkVisibility(assignedLists.id)"
                        class="row-click"
                      >
                        <td>
                          <p v-if="!opened.includes(assignedLists.id)">
                            <i class="bi bi-chevron-right"></i>
                          </p>
                          <p v-else>
                            <i class="bi bi-chevron-down"></i>
                          </p>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/partners/profile/${assignedLists.partner_id}`"
                          >
                            <!--                          {{ assignedLists.name }}-->
                            {{
                              driverDetails.find(
                                (driver) =>
                                  driver.user_code === assignedLists.partner_id
                              )
                                ? driverDetails.find(
                                    (driver) =>
                                      driver.user_code ===
                                      assignedLists.partner_id
                                  ).name
                                : 'No User Found'
                            }}
                          </router-link>
                        </td>
                        <td>
                          {{
                            assignedLists.Totaltrip
                              ? assignedLists.TotalTrip
                              : 'N/A'
                          }}
                        </td>
                        <td>
                          {{
                            assignedLists.TotalPayable
                              ? assignedLists.TotalPayable
                              : 'N/A'
                          }}
                        </td>
                        <td>
                          {{
                            assignedLists.payment
                              ? assignedLists.payment
                              : 'N/A'
                          }}
                        </td>
                        <td>
                          {{
                            assignedLists.bonus ? assignedLists.bonus : 'N/A'
                          }}
                        </td>
                        <td>
                          {{
                            assignedLists.TripEarning
                              ? assignedLists.TripEarning
                              : 'N/A'
                          }}
                        </td>
                        <td>
                          {{
                            assignedLists.bonousWeekly
                              ? assignedLists.bonousWeekly
                              : 'N/A'
                          }}
                        </td>
                        <td>
                          {{
                            assignedLists.disbursed
                              ? assignedLists.disbursed
                              : 'N/A'
                          }}
                        </td>
                        <td>
                          {{
                            assignedLists.RequestedBy
                              ? assignedLists.RequestedBy
                              : 'N/A'
                          }}
                        </td>
                      </tr>
                      <tr v-if="opened.includes(assignedLists.id)">
                        <td colspan="10">
                          <div class="row">
                            <div class="col-5">
                              <h6 class="contract-text">Contract Details</h6>
                              <span class="contract-deal">
                                <small class="contract-deal-text"
                                  >Price:
                                  {{
                                    new Intl.NumberFormat('en-IN').format(
                                      assignedLists.price
                                    ) || 0
                                  }}
                                  BDT; Bonus:
                                  {{
                                    new Intl.NumberFormat('en-IN').format(
                                      assignedLists.bonus
                                    ) || 0
                                  }}
                                  BDT;</small
                                >
                                <div class="contract-deal-icon mb-1">
                                  <i
                                    class="bi bi-eye mr-3"
                                    data-bs-toggle="modal"
                                    data-bs-target="#contractDetailsModal"
                                    @click="
                                      editContractDetails(
                                        assignedLists.id,
                                        assignedLists.partner_id
                                      )
                                    "
                                  ></i></div
                              ></span>
                            </div>

                            <div class="col-4">
                              <h6 class="contract-text">Trip History</h6>
                              <span class="remarks-section">
                                <small class="contract-deal-text"
                                  >Workdays: 5 days; Bonus..</small
                                ></span
                              >
                              <div class="remarks-icons mb-1">
                                <i
                                  class="bi bi-eye mr-3"
                                  data-bs-toggle="modal"
                                  data-bs-target="#paymentDetailsModal"
                                ></i>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <p class="mt-3 alert alert-danger" style="text-align: center">
                No Data Found 😢
              </p>
            </div>
          </div>

          <div class="" style="float: left">
            <p>Showing {{ this.from }}-{{ this.to }} out of {{ this.total }}</p>
          </div>
        </div>
        <!-- Paginate -->
        <div class="container pb-8" style="margin-right: -12px">
          <paginate
            :totalPages="totalPages"
            :total="total"
            :currentPage="currentPage"
            :perPage="perPage"
            v-on:pagechanged="getAllData"
          ></paginate>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="contractDetailsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Contract Details Edit
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Route:</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.route_name"
                      />
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.route_name }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Distance:</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.distance"
                        @keyup="calculateFarePrice"
                      />
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.distance }} km</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Total Price :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        @keyup="formatConfirmPrice(tripReqPartnerIdData.price)"
                        v-model="tripReqPartnerIdData.price"
                      />
                      <span class="text-muted d-none"
                        >one lakh three thousand six hundred fifty five</span
                      >
                    </template>
                    <template v-else>
                      <p>{{ formatPrice }} BDT</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Bonus :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        @keyup="formatConfirmBonus(tripReqPartnerIdData.bonus)"
                        v-model="tripReqPartnerIdData.bonus"
                      />
                    </template>
                    <template v-else>
                      <p>
                        {{
                          new Intl.NumberFormat('en-IN').format(
                            tripReqPartnerIdData.bonus
                          )
                        }}
                        BDT
                      </p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Weekdays :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <select
                        class="form-select confirm-select"
                        aria-label=".form-select-lg example"
                        :class="{ edit: isEditable }"
                        v-model="formatWorkDays"
                        @change="formatSelectData"
                      >
                        <option value="Sunday-Thursday(5 days)">
                          Sunday-Thursday (5 days)
                        </option>
                        <option value="Saturday-Thursday(6 days)">
                          Saturday-Thursday (6 days)
                        </option>
                      </select>
                    </template>
                    <template v-else>
                      <p>{{ formatWorkDays }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Home Pickup Time :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <input
                        type="time"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="homePickUpTime"
                        @change="changeHomeTime"
                      />
                    </template>
                    <template v-else>
                      <p>{{ homePickUpTimeFormat }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Instruction for RM :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <textarea
                        cols="30"
                        rows="1"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.instruction_for_tm"
                      ></textarea>
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.instruction_for_tm }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Office Pickup Time :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <input
                        type="time"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="officePickUpTime"
                        @change="changeOfficeTime"
                      />
                    </template>
                    <template v-else>
                      <p>{{ officePickUpTimeFormat }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Instruction for Partner :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <textarea
                        cols="30"
                        rows="1"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.instruction_for_sp"
                      ></textarea>
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.instruction_for_sp }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Trip Type :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <select
                        v-model="selectedTripTypeName"
                        @change="selectedTripTypes"
                        class="form-select confirm-select"
                        :class="{ edit: isEditable }"
                      >
                        <template v-for="type in tripTypes" :key="type.id">
                          <option :value="type.name">
                            {{ type.name }}
                          </option>
                        </template>
                      </select>
                    </template>
                    <template v-else>
                      <p>{{ selectedTripTypeName }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <h6 class="">Pickup Points</h6>
              </div>
              <div class="col-12">
                <div class="row" :style="styleCal">
                  <template v-if="pickData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[3].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 5">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[3].name }}</p>
                    </div>
                    <div class="col-1">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="pick in pickData" :key="pick.name">
                      <div :class="calculateColPick">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-record-circle-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0">{{ pick.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h6>Drop Points</h6>
              </div>
              <div class="col-12">
                <div class="row" :style="styleCal">
                  <template v-if="dropData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[3].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 5">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[3].name }}</p>
                    </div>
                    <div class="col-1">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="drop in dropData" :key="drop.name">
                      <div :class="calculateColDrop">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-geo-alt-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0">{{ drop.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="confirm-modal">
              <button class="btn edit-info" @click="makeEditable">
                Edit Info
              </button>

              <!--              <button-->
              <!--                class='btn w-25 contract-button'-->
              <!--                data-bs-dismiss='modal'-->
              <!--                @submit.prevent='confirmPartner'-->
              <!--                :class="isContractFormDataValid ? '' : 'disabled'">-->
              <!--                Submit-->
              <!--              </button>-->
              <button
                class="btn w-25 contract-button"
                id="primarySubmitButton"
                data-bs-dismiss="modal"
                @click="confirmPartner"
              >
                Submit
              </button>

              <!--              <button-->
              <!--                type="button"-->
              <!--                class="btn confirm-submit-button"-->
              <!--                data-bs-dismiss="modal"-->
              <!--                @click="confirmPartner"-->
              <!--              >-->
              <!--                Confirm Contact-->
              <!--              </button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="paymentDetailsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Trip History (This week)</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <table class="table table-responsive payment-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Duty Type</th>
                  <th>Company</th>
                  <th>Route</th>
                  <th>Payment Type</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2022/01/10</td>
                  <td>Both Way</td>
                  <td>XYZ</td>
                  <td>DHAKA-CTG</td>
                  <td>Weekly</td>
                  <td>2000</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--          <div class="modal-footer">-->
          <!--            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>-->
          <!--            <button type="button" class="btn btn-primary">Save changes</button>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
//
import Paginate from '../pagination/Pagination.vue';
import http from '../../config/axios';
import Loader from '../lib/Loader';
import userService from '../../config/axiosUserService';
import numberFormat from '../../helpers/formatNumber';

export default {
  components: {
    Paginate,
    Loader
  },
  data() {
    return {
      assignedLists: [],
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 0,
      to: 0,
      from: 0,
      searchFilter: {
        globalSearch: ''
      },
      searchByStatus: '',
      opened: [],
      isLoading: true,
      driverDetails: [],
      user_service: {
        name: '',
        mobile: ''
      },
      user_code: [],
      contractDetails: [],
      contractFormData: {
        home: '',
        office: '',
        working_days: '',
        week_days: '',
        work_week_days: '',
        tripType: '',
        bonus: '',
        price: '',
        rm: '',
        sp: '',
        total_price: ''
      },
      confirmed: [],
      selectedContractId: '',
      selectedContractPId: '',
      tripTypes: [],
      tripReqPartnerIdData: [],
      isEditable: false,
      pickData: [],
      dropData: [],
      pickUpTime: [],
      global_search: '',
      trip_request_id: '',
      selectedTripTypeName: '',
      permission: ''
    };
  },
  mounted() {
    this.getAllData();
    // this.searchData();
    this.getTripTypes();

    this.permission = localStorage.getItem('userPermission').split(',');
  },
  methods: {
    getAllData(value) {
      http
        .get(
          `v2/partners/triprequests/assigned/partners?page=${value}&global_search=${this.searchFilter.globalSearch}&status_search=${this.searchByStatus}&user_code=${this.user_code}`
        )
        .then((response) => {
          this.assignedLists = response.data.data.data;
          this.total = response.data.data.total;
          this.totalPages = response.data.data.last_page;
          this.currentPage = response.data.data.current_page;
          this.perPage = response.data.data.per_page;
          this.to = response.data.data.to;
          this.from = response.data.data.from;
          this.isLoading = false;
          this.getDriverDetails(
            response.data.data.data.map((user) => user.partner_id)
          );
        });
    },
    getTripRequest() {
      http
        .get(
          `v2/partners/triprequests/${this.trip_request_id}` +
            '?global_search=&page=&user_code='
        )
        .then((response) => {
          this.invitedPartnerList = response.data.data.invitedPartnerList.data;
          this.isLoading = false;
          this.partnerDetails = response.data.data;
          this.countStats = response.data.data.countStats[0];
          this.tripRequest = response.data.data.tripRequest[0];
          this.tripRequestModalData = response.data.data.tripRequest[0];
          this.tripRequestModalData.pickUpTime = this.pickUpTime;
          this.tripRequestModalData.points = this.pickData.concat(
            this.dropData
          );
          this.pickupData = response.data.data.points.filter(
            (point) => point.type === 'PickUp'
          );
          this.dropoffData = response.data.data.points.filter(
            (point) => point.type === 'DropOff'
          );
          this.timePick = response.data.data.pickUpTime;
          this.getDriverDetails(
            response.data.data.invitedPartnerList.data.map(
              (user) => user.partner_id
            )
          );
          this.total = response.data.data.invitedPartnerList.total;
          this.totalPages = response.data.data.invitedPartnerList.last_page;
          this.currentPage = response.data.data.invitedPartnerList.current_page;
          this.perPage = response.data.data.invitedPartnerList.per_page;
          this.to = response.data.data.invitedPartnerList.to;
          this.from = response.data.data.invitedPartnerList.from;
        })
        .catch((error) => {
          console.error('Error', error);
        });
    },

    searchData() {
      this.isLoading = true;
      if (
        this.user_service?.name &&
        Object.keys(this.user_service.name).length != 0
      ) {
        var url = `v1/users/search?field=name&return=mobile,name,user_code&key=${this.user_service.name}`;
        userService
          .get(url)
          .then((response) => {
            let user_info = response.data.data;
            user_info.forEach((users) => {
              this.user_code.push(users.user_code);
            });
            this.getAllData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (
        this.user_service?.mobile &&
        Object.keys(this.user_service.mobile).length != 0
      ) {
        url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${this.user_service.mobile}`;
        userService
          .get(url)
          .then((response) => {
            let user_info = response.data.data;
            user_info.forEach((users) => {
              this.user_code.push(users.user_code);
            });
            this.getAllData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.user_code = [];
      this.getAllData();
    },
    checkVisibility(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.length = 0;
        this.opened.push(id);
        let getTripRequestId = this.assignedLists.find(
          (assignedLists) => assignedLists.id == id
        );
        this.getTripRequest();
        this.trip_request_id = getTripRequestId.trip_request_id;
      }
    },
    getDriverDetails(id) {
      userService
        .get(`v1/users?user_code=${id}&fields=name,mobile,user_code`)
        .then((response) => {
          this.driverDetails = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editContractDetails(id, pId) {
      this.confirmButton(pId, id);
      this.selectedContractId = id;
      this.selectedContractPId = pId;
      http
        .get(`v2/partners/triprequests/partner/${id}`)
        .then((response) => {
          this.contractDetails = response.data.data;

          this.contractFormData.total_price = this.contractDetails.price;
          this.contractFormData.total_price =
            this.contractFormData.total_price.split('.')[0];
          this.contractFormData.total_price = numberFormat(
            this.contractFormData.total_price
          );

          this.contractFormData.bonus =
            this.contractDetails.bonus.split('.')[0];
          this.contractFormData.bonus = numberFormat(
            this.contractFormData.bonus
          );

          let homePick = this.contractDetails.pickUpTime[0].time.split(':')[0];
          let homePickMin =
            this.contractDetails.pickUpTime[0].time.split(':')[1];
          this.contractFormData.home = `${homePick}:${homePickMin}`;

          let officePick =
            this.contractDetails.pickUpTime[1].time.split(':')[0];
          let officePickMin =
            this.contractDetails.pickUpTime[1].time.split(':')[1];
          this.contractFormData.office = `${officePick}:${officePickMin}`;

          this.contractFormData.work_week_days = `${this.contractDetails.week_days}(${this.contractDetails.working_days} days)`;

          this.contractFormData.tripType = this.tripTypes.find(
            (tripType) => tripType.name === this.contractDetails.tripType
          ).id;

          this.contractFormData.price = this.contractDetails.trip_per_price;
          this.contractFormData.rm = this.contractDetails.instruction_for_tm;
          this.contractFormData.sp = this.contractDetails.instruction_for_sp;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    confirmButton(partnerId, id) {
      this.tripPartnerById(id);
      this.isEditable = false;
      // localStorage.removeItem('contractDetailStatus');
      window.localStorage.setItem('pId', partnerId);
      window.localStorage.setItem('id', id);
      // this.invitedPartnerStatus();
      const index = this.confirmed.indexOf(partnerId);
      if (index > -1) {
        this.confirmed.splice(index, 1);
      } else {
        this.confirmed.push(partnerId);
      }
    },

    tripPartnerById(id) {
      http
        .get(`v2/partners/triprequests/partner/${id}`)
        .then((response) => {
          this.tripReqPartnerIdData = response.data.data;
          this.pickUpTime = response.data.data.pickUpTime;
          this.selectedTripTypeName = response.data.data.tripType;
          // filter PickUp data from response.data.data.points
          this.pickData = response.data.data.points.filter(
            (point) => point.type === 'PickUp'
          );
          // filter DropOff data from response.data.data.points
          this.dropData = response.data.data.points.filter(
            (point) => point.type === 'DropOff'
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // invitedPartnerStatus() {
    //   let status = '';
    //   let id = JSON.parse(window.localStorage.getItem('id'));
    //   let partner = this.assignedLists.filter((ipl) => {
    //     return ipl.id == id;
    //   });
    //   if (partner.length > 0) {
    //     if (partner[0].status === 'Interested') {
    //       status = 'Confirm';
    //     } else if (partner[0].status === 'Confirmed') {
    //       status = 'Assign';
    //     }
    //   }
    //   this.partnerStatus = status;
    // },

    formatContractPrice() {
      if (
        this.contractFormData.total_price.trim() === '' ||
        /[a-zA-Z]/g.test(this.contractFormData.total_price)
      ) {
        this.contractFormData.total_price = '0';
      }

      this.contractFormData.total_price =
        this.contractFormData.total_price.replace(/[^0-9]/g, '');
      this.contractFormData.total_price = numberFormat(
        parseInt(this.contractFormData.total_price)
      );
    },
    formatContractBonus() {
      if (
        this.contractFormData.bonus.trim() === '' ||
        /[a-zA-Z]/g.test(this.contractFormData.bonus)
      ) {
        this.contractFormData.bonus = '0';
      }

      this.contractFormData.bonus = this.contractFormData.bonus.replace(
        /[^0-9]/g,
        ''
      );
      this.contractFormData.bonus = numberFormat(
        parseInt(this.contractFormData.bonus)
      );
    },

    formatSelectData(e) {
      let workDays = e.target.value;
      let splitWeekDays = workDays.split('(');
      let week_days = workDays.split('(')[0];
      let working_days = splitWeekDays[1].split(' ')[0];
      this.tripReqPartnerIdData.working_days = +working_days;
      this.tripReqPartnerIdData.week_days = week_days;

      let trip = this.tripReqPartnerIdData.working_days === 5 ? 44 : 56;

      this.tripReqPartnerIdData.price = parseInt(
        trip *
          Number(this.tripReqPartnerIdData.trip_per_price) *
          this.tripReqPartnerIdData.distance
      );

      this.tripReqPartnerIdData.price = numberFormat(
        this.tripReqPartnerIdData.price
      );
    },
    makeEditable() {
      this.isEditable = true;
      this.tripReqPartnerIdData.price = this.tripReqPartnerIdData.price.replace(
        /,/g,
        ''
      );
      this.tripReqPartnerIdData.price =
        this.tripReqPartnerIdData.price.split('.')[0];
      this.tripReqPartnerIdData.price = numberFormat(
        this.tripReqPartnerIdData.price
      );

      this.tripReqPartnerIdData.bonus = this.tripReqPartnerIdData.bonus.replace(
        /,/g,
        ''
      );
      this.tripReqPartnerIdData.bonus =
        this.tripReqPartnerIdData.bonus.split('.')[0];
      this.tripReqPartnerIdData.bonus = numberFormat(
        this.tripReqPartnerIdData.bonus
      );

      this.tripReqPartnerIdData.distance =
        this.tripReqPartnerIdData.distance.split('.')[0];
    },
    confirmPartner() {
      let partnerId = window.localStorage.getItem('pId');
      let id = window.localStorage.getItem('id');
      let tripType = this.tripTypes.filter(
        (tripType) => tripType.name === this.selectedTripTypeName
      );
      // console.log('ipl',this.invitedPartnerList);
      // let getPartnerById = this.invitedPartnerList.find((ipl) => ipl.id == id);
      // console.log('getPt',getPartnerById);
      //
      // let partnerStatus = '';

      // if (!localStorage.getItem('contractDetailStatus')) {
      //   if (getPartnerById.status == 'Interested') {
      //     partnerStatus = 'Confirmed';
      //   }
      //   if (getPartnerById.status == 'Confirmed') {
      //     partnerStatus = 'Assigned';
      //   }
      // } else {
      //   localStorage.removeItem('contractDetailStatus');
      // }
      //partnerStatus = getPartnerById.status;

      let partnerData = {
        distance: this.tripReqPartnerIdData.distance,
        route_name: this.tripReqPartnerIdData.route_name,
        trip_request_to_partner_id: id,
        bonus: this.tripReqPartnerIdData.bonus.split(',').join(''),
        price: this.tripReqPartnerIdData.price.split(',').join(''),
        working_days: this.tripReqPartnerIdData.working_days,
        week_days: this.tripReqPartnerIdData.week_days,
        tripType: tripType[0].id,
        instruction_for_tm: this.tripReqPartnerIdData.instruction_for_tm,
        instruction_for_sp: this.tripReqPartnerIdData.instruction_for_sp,
        // status: partnerStatus,
        pickUpTime: [...this.pickUpTime]
        // points: [...this.pickData.concat(this.dropData)]
      };

      http
        .put(`v2/partners/triprequests/invitations/${partnerId}`, partnerData)
        .then((response) => {
          if (response.status === 200) {
            this.getAllData();
            this.getTripRequest();
            this.isEditable = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeHomeTime(e) {
      this.pickUpTime[0].time = e.target.value;
    },
    changeOfficeTime(e) {
      this.pickUpTime[1].time = e.target.value;
    },
    selectedTripTypes(e) {
      this.selectedTripTypeName = e.target.value;
    },
    formatConfirmPrice() {
      if (
        this.tripReqPartnerIdData.price.trim() === '' ||
        /[a-zA-Z]/g.test(this.tripReqPartnerIdData.price)
      ) {
        this.tripReqPartnerIdData.price = '0';
      }
      this.tripReqPartnerIdData.price = this.tripReqPartnerIdData.price.replace(
        /[^0-9]/g,
        ''
      );
      this.tripReqPartnerIdData.price = numberFormat(
        parseInt(this.tripReqPartnerIdData.price)
      );
    },
    getTripTypes() {
      http.get('v2/trips/types').then((res) => {
        this.tripTypes = res.data.data;
      });
    }
  },
  computed: {
    styleCal() {
      if (this.pickData.length === 5 && this.dropData.length === 5) {
        return '--bs-gutter-x: 0; width: 53.8rem';
      }
      return '--bs-gutter-x: 0';
    },
    homePickUpTime() {
      let h = '',
        m = '';
      if (Object.keys(this.pickUpTime).length && this.pickUpTime.length) {
        h = this.pickUpTime[0].time.split(':')[0];
        m = this.pickUpTime[0].time.split(':')[1];
      }
      return h + ':' + m;
    },
    homePickUpTimeFormat() {
      let timeString = this.homePickUpTime;
      const formatTime = new Date(
        '2021-12-01T' + timeString + 'Z'
      ).toLocaleTimeString('en-US', {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric'
      });
      return formatTime;
    },
    officePickUpTime() {
      let h = '',
        m = '';
      if (Object.keys(this.pickUpTime).length && this.pickUpTime.length) {
        h = this.pickUpTime[1].time.split(':')[0];
        m = this.pickUpTime[1].time.split(':')[1];
      }
      return h + ':' + m;
    },
    officePickUpTimeFormat() {
      let timeString = this.officePickUpTime;
      const formatTime = new Date(
        '2021-12-01T' + timeString + 'Z'
      ).toLocaleTimeString('en-US', {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric'
      });
      return formatTime;
    },

    tripTypeSelection() {
      let trip = {};
      if (Object.keys(this.tripRequestModalData).length) {
        trip = this.tripTypes.find(
          (trip) => trip.name === this.tripRequestModalData.tripType
        );
      }
      return Object.keys(trip).length && trip.id;
    },

    pickLength() {
      return this.pickupData.length - 1;
    },
    dropLength() {
      return this.dropoffData.length - 1;
    },
    calculateColDrop() {
      if (this.dropData.length > 6) {
        return 'col-2';
      }
      return 'col-' + Math.floor(12 / this.dropData.length);
    },

    tripHomeTimeFormatData() {
      let h = '',
        m = '';
      if (Object.keys(this.timePick).length && this.timePick.length) {
        h = this.timePick[0].time.split(':')[0];
        m = this.timePick[0].time.split(':')[1];
      }
      return new Date('2021-12-01T' + `${h}:${m}` + 'Z').toLocaleTimeString(
        'en-US',
        {
          timeZone: 'UTC',
          hour12: true,
          hour: 'numeric',
          minute: 'numeric'
        }
      );
    },
    tripOfficeTimeFormatData() {
      let h = '',
        m = '';
      if (Object.keys(this.timePick).length && this.timePick.length) {
        h = this.timePick[1].time.split(':')[0];
        m = this.timePick[1].time.split(':')[1];
      }
      return new Date('2021-12-01T' + `${h}:${m}` + 'Z').toLocaleTimeString(
        'en-US',
        {
          timeZone: 'UTC',
          hour12: true,
          hour: 'numeric',
          minute: 'numeric'
        }
      );
    },
    formatWorkDays() {
      return `${this.tripReqPartnerIdData.week_days}(${this.tripReqPartnerIdData.working_days} days)`;
    }
  }
};
</script>

<style scoped>
.assigned-partners {
  font-family: Montserrat;
}

.table thead,
tr,
th {
  vertical-align: bottom;
  border-bottom: 2px solid #f8f9fa;
  background: #f3f3f3;
}

.table tbody,
tr,
td {
  font-size: 15px;
  background-color: #ffffff;
}

#assign-partner-search {
  background: #1c2457;
}

.input-group {
  width: 15.2rem;
}

input {
  background: #ddd;
  color: black;
}

.form-select {
  color: black !important;
  background-color: #ddd;
}

.confirm-button {
  background: #262c66;
  border: none;
  height: 30px;
  border-radius: 8px;
  color: #ffffff;
  width: 35%;
  text-align: center;
}

.confirm-modal {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 4rem;
  width: 44rem;
}

.confirm-modal .edit-info {
  background: none;
  color: #0d0d0d;
  margin-left: 130px;
}

.edit {
  outline: none;
  border: 1px solid #a5b9f1 !important;
  font-size: 14px !important;
  padding: 5px !important;
  background: url('http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png')
    white no-repeat 98.5% !important;
  background: url('http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png')
    white no-repeat calc(100% - 10px) !important;
}

.form-control-plaintext {
  background: transparent !important;
}

.confirm-select {
  border: none;
  background: none;
  padding: 2px;
}

.payment-table {
  font-family: Montserrat;
  font-size: 12px;
}
.payment-table th {
  background: #f3f3f3;
  font-family: Montserrat;
  font-size: 12px;
}

.payment-table td {
  background: #ffffff;
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 12px;
}
#primarySubmitButton {
  background: #1c2457;
  color: white;
  font-family: Montserrat;
}

#primarySubmitButton:hover,
#primarySubmitButton:focus,
#primarySubmitButton:active {
  background: #1c2457;
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .dataTables_filter,
  .dataTables_info {
    display: none;
  }

  .filter-style {
    text-align: center;
  }

  .dropdown {
    text-align: end;
  }
}

@media (min-width: 768px) {
}
</style>
